import { render, staticRenderFns } from "./TemplateContent.vue?vue&type=template&id=b11f94b0&scoped=true"
import script from "./TemplateContent.vue?vue&type=script&lang=js"
export * from "./TemplateContent.vue?vue&type=script&lang=js"
import style0 from "./TemplateContent.vue?vue&type=style&index=0&id=b11f94b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11f94b0",
  null
  
)

export default component.exports